import { Injectable } from '@angular/core'

@Injectable()
export class FormHelperService {
    scrollToInvalidElement() {
        const firstElementWithError = document.querySelector('form .ng-invalid')
        this.scrollTo(firstElementWithError)
    }

    private scrollTo(el: Element) {
        if (el) {
            el.scrollIntoView({ behavior: 'smooth' })
        }
    }
}
